import { IconHeartOff16, IconHeartOn16 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import { FavoritesButtonContext } from 'shared/context';

import * as styles from './DefaultFavoriteButton.css';

export interface IDefaultFavoriteButtonProps {
  checked: boolean;
  onButtonClick(): void;
}

export const DefaultFavoriteButton = ({ checked, onButtonClick }: IDefaultFavoriteButtonProps) => {
  const { customClass } = React.useContext(FavoritesButtonContext);
  const Icon = checked ? IconHeartOn16 : IconHeartOff16;

  return (
    <button onClick={onButtonClick} className={cx(styles['btn'], customClass ? customClass : styles['btn-default'])}>
      <span className={styles['btn-inner']}>
        <div className={styles['content']}>
          <span className={styles['icon']}>
            <Icon color="current_color" />
          </span>
          <span className={styles['text']}>{checked ? 'В избранном' : 'В избранное'}</span>
        </div>
      </span>
    </button>
  );
};
